import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {environment} from "@env/environment";
import {ModalController} from "@ionic/angular";
import {DoctorPanelActions} from "@modules/doctor-panel/store/doctor-panel.actions";
import {DoctorPanelState} from "@modules/doctor-panel/store/doctor-panel.state";
import {hasActionsExecuting} from "@ngxs-labs/actions-executing";
import {Select, Store} from "@ngxs/store";
import {Observable, Subscription} from "rxjs";

@Component({
  selector: "app-dialog-prescription-pdta",
  templateUrl: "./dialog-prescription-pdta.component.html",
  styleUrls: ["./dialog-prescription-pdta.component.scss"],
  standalone: false
})
export class DialogPrescriptionPdtaComponent implements OnInit, OnDestroy {
  @Input()
  prescriptionUrl?: any[];

  @Input()
  parentContext: string;

  @Input()
  trecUserId: string;

  private readonly subscr = new Subscription();
  @Select(DoctorPanelState.prescriptionUrlPdta) prescriptionUrlPdta$: Observable<any[]>;

  @Select(hasActionsExecuting([DoctorPanelActions.PrescriptionUrlPdta]))
  loading$: Observable<boolean>;

  constructor(private modalCtrl: ModalController, private store: Store) { }

  ngOnInit(): void {
    this.subscr.add(
      this.prescriptionUrlPdta$.subscribe((prescriptionUrlPdta) => {
        if (prescriptionUrlPdta) {
          this.prescriptionUrl = prescriptionUrlPdta;
        }
      })
    );
  }

  prescrivi(prescription: any, event: Event) {
    event.stopPropagation();
    let prescritipionUrl = prescription.url;
    prescritipionUrl = prescritipionUrl.replace("_SERVICE_", environment.websanityServicePrescrivi);
    window.open(prescritipionUrl, "_blank");
  }

  prenota(prescription: any, event: Event) {
    event.stopPropagation();
    let prescritipionUrl = prescription.url;
    prescritipionUrl = prescritipionUrl.replace("_SERVICE_", environment.websanityServicePrenota);

    window.open(prescritipionUrl, "_blank");
  }

  refresh() {
    if (this.parentContext) {
      this.store.dispatch(
        new DoctorPanelActions.PrescriptionUrlPdta({
          trecUserId: this.trecUserId,
          context: this.parentContext,
        })
      );
    }
  }

  onClose() {
    this.modalCtrl.dismiss();
  }

  ngOnDestroy(): void {
    this.subscr?.unsubscribe();
  }
}
